export default "__VITE_ASSET__CtLI85l4__"